import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "BuddyListItemPageCountTooltip"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {}
  },
  setup(__props: any) {

let props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, _toDisplayString(_unref(__)('Посещено страниц за этот заход')) + ": " + _toDisplayString(__props.userdata.visitStatistic.lastVisitPageCount), 1),
    (__props.userdata.visitStatistic.visitCount > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(__)('Всего')) + ": " + _toDisplayString(__props.userdata.visitStatistic.visitedPageCount), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})